<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Garaj</label>
            <v-validator :errors="errors" parameter="VehicleInventoryGarageId" :watch="garage">
                <v-select-list  placeholder="Garaj" v-model="garage" label="GarageName" :options="garages"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Geçerlilik Başlangıç Tarihi</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                <flat-pickr v-model="value.Date" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d', locale:'tr'}" placeholder="Geçerlilik Başlangıç Tarihi"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Maaş</label>
            <v-validator :errors="errors" parameter="Salary" :watch="value.Salary">
                <input class="form-control" type="number" placeholder="Maaş" v-model="value.Salary"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import VehicleOperationsApi from '@/api/vehicle-operations'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
export default {
    components:{
        flatPickr,
    },
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getGarages();
    },
    data(){
        return {
            garages:[],
        }
    },
    methods:{
        getGarages(){
            VehicleOperationsApi.Garage.List().then(res=>{
                this.garages = res.data.Data
            })
        }
    },
    computed:{
        garage:{
            get:function(){
                return this.garages.find(b=>b.Id == this.value.VehicleInventoryGarageId)
            },
            set:function(value){
                this.value.VehicleInventoryGarageId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>